import React from "react";
import GenerateurAttestationHebergement from "../components/GenerateurAttestationHebergement";
import { useSEO } from "../hooks/useSEO";

export default function GenerateurAttestationHebergementPage() {
  useSEO({
    title: "Générateur Attestation d'Hébergement PDF Gratuit",
    description: "Générez gratuitement une attestation d'hébergement en PDF. Modèle officiel à télécharger, conforme aux exigences administratives françaises."
  });

  return <GenerateurAttestationHebergement />;
}
